import AppRoot from '../../../external/tag-cloud-widget/containers/app-root';
import { withViewer } from '../../../external/common/hoc/with-viewer';

export default withViewer(AppRoot);
